// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("app.min." + "2182ab119334eb247238" + ".js");